import React from 'react';
import theme from 'source/theme';

export default ({ row }) =>
  <div style={{ backgroundColor: theme.palette.background.light }}>
    <ul style={{ margin: 0, paddingTop: 10, paddingBottom: 10 }}>
      {
        row.substances.map( substance =>
          <React.Fragment key={ substance.name}>
            <li>{ substance.name}</li>
            <ul style={{ margin: 0, paddingTop: 2, paddingBottom: 2 }}>
              {
                row.shipmentsBySubstanceId[substance.id].map(shipment =>
                  <li
                    key={shipment.code}>{shipment.code + ' - ' + shipment.trade_name}
                    {
                      shipment.value ?
                        <span> -&nbsp;
                          <span style={{ backgroundColor: theme.palette.background.veryLight, borderRadius: '5px' }}>
                             Valor: {shipment.value + ' ' + shipment.unit}
                          </span>
                        </span> :
                        null
                    }
                    {
                      shipment.notes && shipment.notes !== ''  ?
                        <span> -&nbsp;
                          <span style={{ color: theme.palette.background.veryLight }}>
                             Notas: {shipment.notes}
                          </span>
                        </span> :
                        null
                    }
                  </li>
                )
              }
            </ul>
          </React.Fragment>
        )
      }
    </ul>
  </div>;
